import React from "react"
import { TouchableOpacity, View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"
import CustomScrollableContentWithBackHeader from "@Components/CustomScrollableContentWithBackHeader/CustomScrollableContentWithBackHeader"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import FakeVideosContent from "@assets/images/FakeVideosContent"

const IvehteHistory = () => {
    return (
        <CustomScrollableContentWithBackHeader>
            <View style={styles.header}>
                <BreeSerifText style={styles.title} fontSize={RFValue(24)}>
                    L’histoire d’IVEHTE{" "}
                </BreeSerifText>

                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={RFValue(16)}>
                    Découvrez l’histoire d’IVEHTE !{" "}
                </OpenSansText>
            </View>

            <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(16)}>
                IVEHTE, qui veut dire “In Vivo E-Health and Therapeutic Education”, est à l’origine une association qui
                a vu le jour en 2020.{" "}
            </OpenSansText>

            <View style={styles.content}>
                <BreeSerifText style={styles.missionLabel} fontSize={RFValue(20)}>
                    IVEHTE, une association
                </BreeSerifText>

                <TouchableOpacity activeOpacity={0.6} style={styles.videoContainer}>
                    <FakeVideosContent style={{ backgroundColor: baseColors.green.pastel }} />
                </TouchableOpacity>

                <BreeSerifText style={styles.missionLabel} fontSize={RFValue(20)}>
                    L’application IVEHTE a vu le jour en 2021. Elle est la suite logique dans la mission de
                    l’association. L’application IVEHTE a vu le jour en 2021. Elle est la suite logique dans la mission
                    de l’association. L’application IVEHTE a vu le jour en 2021. Elle est la suite logique dans la
                    mission de l’association.
                </BreeSerifText>
            </View>
        </CustomScrollableContentWithBackHeader>
    )
}

export default IvehteHistory
